var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Checkbox, Typography } from "@material-ui/core";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
var CheckboxRowTextContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: center;\n  flex: 1;\n  position: relative;\n  top: 1px;\n"], ["\n  align-self: center;\n  flex: 1;\n  position: relative;\n  top: 1px;\n"])));
var CheckboxRowContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var MarkdownTextWithoutMargin = styled(MarkdownText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  p {\n    margin: 0;\n  }\n"], ["\n  p {\n    margin: 0;\n  }\n"])));
var CheckboxOption = function CheckboxOption(_a) {
  var item = _a.item;
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var dispatch = useDispatch();
  var option = item.options[0];
  var body;
  var title;
  if (option) {
    body = option.body;
    title = option.title;
  } else {
    body = item.body;
    title = item.title;
  }
  var answerLocked = userQuizState && userQuizState.status === "locked" ? true : false;
  var toggle = function toggle() {
    if (answerLocked) {
      return;
    }
    dispatch(quizAnswerActions.changeCheckboxData(item.id, option === null || option === void 0 ? void 0 : option.id));
  };
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var optionAnswer = itemAnswer && itemAnswer.optionAnswers[0];
  var answer = (optionAnswer === null || optionAnswer === void 0 ? void 0 : optionAnswer.quizOptionId) !== undefined;
  if (!answer) {
    answer = (itemAnswer === null || itemAnswer === void 0 ? void 0 : itemAnswer.intData) === 1;
  }
  var checkboxOptions = {
    disabled: answerLocked || quizDisabled,
    checked: answer && !quizDisabled
  };
  return React.createElement(CheckboxRowContainer, null, React.createElement("div", null, React.createElement(Checkbox, __assign({
    value: answer,
    color: "primary",
    onChange: toggle
  }, checkboxOptions, {
    inputProps: {
      "aria-label": "" + title
    }
  }))), React.createElement(CheckboxRowTextContainer, {
    onClick: toggle
  }, title && React.createElement(MarkdownTextWithoutMargin, {
    Component: Typography,
    variant: "subtitle1",
    variantMapping: {
      subtitle1: "p"
    }
  }, title), body && body !== title && React.createElement(MarkdownTextWithoutMargin, {
    Component: Typography,
    variant: "body1"
  }, body)));
};
export default CheckboxOption;
var templateObject_1, templateObject_2, templateObject_3;